import { connect } from "react-redux";
import SalesforceImportHistoryDetail from "../components/AccountSetting/Salesforce/SalesforceImportHistory/SalesforceImportHistoryDetail";
import { goBack, push } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  errorMessage: state.sfdcExeSetting.errorMessage,
  shortMessage: state.sfdcExeSetting.shortMessage,
  successMessage: state.sfdcExeSetting.successMessage,
  isLoadingImportHistory: state.salesforce.isLoadingImportHistory,
  importHistory: state.salesforce.importHistory,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceImportHistoriesById(id) {
    dispatch(actions.getSalesforceImportHistoriesById(id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceImportHistoryDetail);



// WEBPACK FOOTER //
// ./src/containers/SalesforceImportHistory.js